import React, { createContext, useState } from 'react';

export const TriviaUserDataContext = createContext();

export const TriviaUserDataProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  return (
    <TriviaUserDataContext.Provider value={{ user, setUser }}>
      {children}
    </TriviaUserDataContext.Provider>
  );
};